<script lang="ts" setup>
import type { Props, Slots } from './types';

withDefaults(defineProps<Props>(), {
	styling: 'default',
	size: 'default',
});

defineSlots<Slots>();
</script>

<template>
	<div
		:class="{
			['top-info']: true,
			['top-size_' + size]: true,
			['top-info-styling_' + styling]: true,
		}"
		:data-top-icon="icon"
	>
		<div class="top-info_text">
			<slot></slot>
		</div>

		<span v-if="$slots.additional" class="top-info_value">
			<slot name="additional"></slot>
		</span>
	</div>
</template>

<style>
.top-info {
	--top-icon-width: var(--top-icon-size);

	border-radius: var(--top-forms-radius);
	box-sizing: border-box;
	min-height: var(--top-forms-base-height);
	padding: var(--top-padding-1) var(--top-padding-2);
	flex-grow: 5;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--top-gap-2);
}

.top-info_text {
	flex-grow: 1;
}

.top-info_value {
	font-weight: bold;
}

/* size */
.top-info.top-size_default {
	border-radius: var(--top-radius-3);
	padding: var(--top-padding-4);
}

/* styling */
.top-info-styling_default {
	--top-icon-color: var(--color-text-2);

	background: var(--color-layer-1);
}

.top-info-styling_info {
	--top-icon-color: var(--color-text-primary);

	background: var(--color-layer-primary-1);
}

.top-info-styling_warning {
	--top-icon-color: var(--color-text-warning);

	background: var(--color-layer-warning-1);
}

.top-info-styling_negative {
	--top-icon-color: var(--color-text-negative);

	background: var(--color-layer-negative-1);
}
</style>
